import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import { Col, Row } from "react-bootstrap";
import Loading from "../components/loading/Loading";
import UploadIMG from "../components/uploads/UploadIMG";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { createAndUpdateHome, getDataHome } from "../api/admin_cms"
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function Home() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [txtEnDescAllSeasons, setTxtEnDescAllSeasons] = useState('');
    const [txtThDescAllSeasons, setTxtThDescAllSeasons] = useState('');
    const [txtEnDescOfficeBuilding, setTxtEnDescOfficeBuilding] = useState('');
    const [txtThDescOfficeBuilding, setTxtThDescOfficeBuilding] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [txtEnDescRetail, setTxtEnDescRetail] = useState('');
    const [txtThDescRetail, setTxtThDescRetail] = useState('');
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [txtEnDescCondominium, setTxtEnDescCondominium] = useState('');
    const [txtThDescCondominium, setTxtThDescCondominium] = useState('');
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [txtEnDescConrad, setTxtEnDescConrad] = useState('');
    const [txtThDescConrad, setTxtThDescConrad] = useState('');
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);
    const [txtEnDescCareer, setTxtEnDescCareer] = useState('');
    const [txtThDescCareer, setTxtThDescCareer] = useState('');
    const [images5, setImages5] = useState([]);
    const [imagesFromApi5, setImagesFromApi5] = useState([]);

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };

    const handleSelectedImages4 = (images) => {
        setImages4(images);
    };
    const handleSelectedRemoveImg4 = (data) => {
        setImages4(data);
    };

    const handleSelectedImages5 = (images) => {
        setImages5(images);
    };
    const handleSelectedRemoveImg5 = (data) => {
        setImages5(data);
    };

    const [dataHome, setDataHome] = useState({
        linkVR: null,
        linkConrad: null,
    });

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
        try {
            if (editId) {
                const formatedBodyToServer = {
                    asp_virtual_link: dataHome.linkVR,
                    conrad_link: dataHome.linkConrad,
                    asp_description_en: txtEnDescAllSeasons,
                    asp_description_th: txtThDescAllSeasons,
                    offfice_description_en: txtEnDescOfficeBuilding,
                    offfice_description_th: txtThDescOfficeBuilding,
                    office_image: images1 ?? null,
                    retail_description_en: txtEnDescRetail,
                    retail_description_th: txtThDescRetail,
                    retail_image: images2 ?? null,
                    condo_description_en: txtEnDescCondominium,
                    condo_description_th: txtThDescCondominium,
                    condo_image: images3 ?? null,
                    conrad_description_en: txtEnDescConrad,
                    conrad_description_th: txtThDescConrad,
                    conrad_image: images4 ?? null,
                    career_description_en: txtEnDescCareer,
                    career_description_th: txtThDescCareer,
                    career_image: images5 ?? null,
                }
                if (
                    !formatedBodyToServer.asp_virtual_link ||
                    !formatedBodyToServer.conrad_link ||
                    !formatedBodyToServer.asp_description_en ||
                    !formatedBodyToServer.asp_description_th ||
                    !formatedBodyToServer.offfice_description_en ||
                    !formatedBodyToServer.offfice_description_th ||
                    !formatedBodyToServer.office_image.length > 0 ||
                    !formatedBodyToServer.retail_description_en ||
                    !formatedBodyToServer.retail_description_th ||
                    !formatedBodyToServer.retail_image.length > 0 ||
                    !formatedBodyToServer.condo_description_en ||
                    !formatedBodyToServer.condo_description_th ||
                    !formatedBodyToServer.condo_image.length > 0 ||
                    !formatedBodyToServer.conrad_description_en ||
                    !formatedBodyToServer.conrad_description_th ||
                    !formatedBodyToServer.conrad_image.length > 0 ||
                    !formatedBodyToServer.career_description_en ||
                    !formatedBodyToServer.career_description_th ||
                    !formatedBodyToServer.career_image.length > 0
                ) {
                  await alertValidate(
                    {
                        title: "Please fill your information completely.",
                        text: "กรุณากรอกข้อมูลให้ครบถ้วน"
                    });
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                          (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateHome(formatedBodyToServer);
                            setLoading(false)
                              if (response.status == "success") {
                                const result = await alertSaved();
                                  if (result.isConfirmed) {
                                    window.location.reload();
                                  }
                              }
                          })();
                        }
                }
            } else {
                const formatedBodyToServer = {
                    asp_virtual_link: dataHome.linkVR,
                    conrad_link: dataHome.linkConrad,
                    asp_description_en: txtEnDescAllSeasons,
                    asp_description_th: txtThDescAllSeasons,
                    offfice_description_en: txtEnDescOfficeBuilding,
                    offfice_description_th: txtThDescOfficeBuilding,
                    office_image: images1 ?? null,
                    retail_description_en: txtEnDescRetail,
                    retail_description_th: txtThDescRetail,
                    retail_image: images2 ?? null,
                    condo_description_en: txtEnDescCondominium,
                    condo_description_th: txtThDescCondominium,
                    condo_image: images3 ?? null,
                    conrad_description_en: txtEnDescConrad,
                    conrad_description_th: txtThDescConrad,
                    conrad_image: images4 ?? null,
                    career_description_en: txtEnDescCareer,
                    career_description_th: txtThDescCareer,
                    career_image: images5 ?? null,
                }
                if (
                    !formatedBodyToServer.asp_virtual_link ||
                    !formatedBodyToServer.conrad_link ||
                    !formatedBodyToServer.asp_description_en ||
                    !formatedBodyToServer.asp_description_th ||
                    !formatedBodyToServer.offfice_description_en ||
                    !formatedBodyToServer.offfice_description_th ||
                    !formatedBodyToServer.office_image.length > 0 ||
                    !formatedBodyToServer.retail_description_en ||
                    !formatedBodyToServer.retail_description_th ||
                    !formatedBodyToServer.retail_image.length > 0 ||
                    !formatedBodyToServer.condo_description_en ||
                    !formatedBodyToServer.condo_description_th ||
                    !formatedBodyToServer.condo_image.length > 0 ||
                    !formatedBodyToServer.conrad_description_en ||
                    !formatedBodyToServer.conrad_description_th ||
                    !formatedBodyToServer.conrad_image.length > 0 ||
                    !formatedBodyToServer.career_description_en ||
                    !formatedBodyToServer.career_description_th ||
                    !formatedBodyToServer.career_image.length > 0
                ) {
                    await alertValidate(
                        {
                            title: "Please fill your information completely.",
                            text: "กรุณากรอกข้อมูลให้ครบถ้วน"
                        });
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                          (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateHome(formatedBodyToServer);
                            setLoading(false)
                              if (response.status == "success") {
                                const result = await alertSaved();
                                  if (result.isConfirmed) {
                                    window.location.reload();
                                  }
                              }
                          })();
                        }
                }
            }
        } catch (error) {
            console.log('found error ', error)
        }
        await setLoading(false);
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    window.location.reload();
                }
                else { }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const result = await getDataHome()
            setEditId(result?.data?._id)
            setTxtEnDescAllSeasons(result?.data?.asp_description_en)
            setTxtThDescAllSeasons(result?.data?.asp_description_th)
            setDataHome(prevData => ({
                ...prevData,
                linkVR: result?.data?.asp_virtual_link
            }));
            setTxtEnDescOfficeBuilding(result?.data?.offfice_description_en)
            setTxtThDescOfficeBuilding(result?.data?.offfice_description_th)
            setTxtEnDescRetail(result?.data?.retail_description_en)
            setTxtThDescRetail(result?.data?.retail_description_th)
            setTxtEnDescCondominium(result?.data?.condo_description_en)
            setTxtThDescCondominium(result?.data?.condo_description_th)
            setTxtEnDescConrad(result?.data?.conrad_description_en)
            setTxtThDescConrad(result?.data?.conrad_description_th)
            setDataHome(prevData => ({
                ...prevData,
                linkConrad: result?.data?.conrad_link
            }));
            setTxtEnDescCareer(result?.data?.career_description_en)
            setTxtThDescCareer(result?.data?.career_description_th)
            setImagesFromApi1([{
                id: 0,
                status: false,
                src:
                    result?.data?.office_image === null ||
                    result?.data?.office_image === ""
                    ? ''
                    : result?.data?.office_image,
                file: result?.data?.office_image ? await urlToBlob(result?.data?.office_image) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi2([{
                id: 0,
                status: false,
                src:
                    result?.data?.retail_image === null ||
                    result?.data?.retail_image === ""
                    ? ''
                    : result?.data?.retail_image,
                file: result?.data?.retail_image ? await urlToBlob(result?.data?.retail_image) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi3([{
                id: 0,
                status: false,
                src:
                    result?.data?.condo_image === null ||
                    result?.data?.condo_image === ""
                    ? ''
                    : result?.data?.condo_image,
                file: result?.data?.condo_image ? await urlToBlob(result?.data?.condo_image) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi4([{
                id: 0,
                status: false,
                src:
                    result?.data?.conrad_image === null ||
                    result?.data?.conrad_image === ""
                    ? ''
                    : result?.data?.conrad_image,
                file: result?.data?.conrad_image ? await urlToBlob(result?.data?.conrad_image) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi5([{
                id: 0,
                status: false,
                src:
                    result?.data?.career_image === null ||
                    result?.data?.career_image === ""
                    ? ''
                    : result?.data?.career_image,
                file: result?.data?.career_image ? await urlToBlob(result?.data?.career_image) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
        } catch (error) {
            console.log('found error', error)
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])
  return (
    <>
        {isLoading ? <Loading /> : ""}
        <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
        </style>
        <Header parentmenu={"HOME"} />
        <Menu
            parentmenu={"infoHome"}
            activemenu={"infoHome"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-home.png" className="ic-user01 me-2" alt="" />
                                HOME
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    All Seasons Place <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescAllSeasons}
                                    onChange={(newData) => {
                                        setTxtEnDescAllSeasons(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescAllSeasons}
                                    onChange={(newData) => {
                                        setTxtThDescAllSeasons(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>360 Virtual <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkVR"
                                            placeholder="Enter Link 360"
                                            value={dataHome.linkVR}
                                            onChange={(event) =>
                                                setDataHome({
                                                    ...dataHome,
                                                    linkVR: event.target.value,
                                                })
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Office Building <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescOfficeBuilding}
                                    onChange={(newData) => {
                                        setTxtEnDescOfficeBuilding(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescOfficeBuilding}
                                    onChange={(newData) => {
                                        setTxtThDescOfficeBuilding(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={8}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Image Cover <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages1}
                                            images={imagesFromApi1}
                                            txtDetail={"jpg. / 1920x580 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg1}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Retail Center <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescRetail}
                                    onChange={(newData) => {
                                        setTxtEnDescRetail(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescRetail}
                                    onChange={(newData) => {
                                        setTxtThDescRetail(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={8}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Image Cover <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages2}
                                            images={imagesFromApi2}
                                            txtDetail={"jpg. / 1920x580 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg2}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Condominium <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescCondominium}
                                    onChange={(newData) => {
                                        setTxtEnDescCondominium(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescCondominium}
                                    onChange={(newData) => {
                                        setTxtThDescCondominium(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={8}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Image Cover <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages3}
                                            images={imagesFromApi3}
                                            txtDetail={"jpg. / 1920x580 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg3}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Conrad Bangkok <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescConrad}
                                    onChange={(newData) => {
                                        setTxtEnDescConrad(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescConrad}
                                    onChange={(newData) => {
                                        setTxtThDescConrad(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={8}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Image Cover <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages4}
                                            images={imagesFromApi4}
                                            txtDetail={"jpg. / 1920x580 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg4}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={4} className='d-flex align-items-center'>
                                <Row className='align-items-center w-100'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Link <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Conrad Bangkok"
                                            value={dataHome.linkConrad}
                                            onChange={(event) =>
                                                setDataHome({
                                                    ...dataHome,
                                                    linkConrad: event.target.value,
                                                })
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Careers Job <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDescCareer}
                                    onChange={(newData) => {
                                        setTxtEnDescCareer(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDescCareer}
                                    onChange={(newData) => {
                                        setTxtThDescCareer(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={8}>
                                <Row className='align-items-center'>
                                    <Col xs={3}><span className='fontReg font-size03 colorBlack01'>Image Cover <span className=' colorRed'>*</span></span></Col>
                                    <Col xs={9} className='pe-1'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages5}
                                            images={imagesFromApi5}
                                            txtDetail={"jpg. / 1920x580 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg5}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                            disabled={isLoading} // ปิดการใช้งานปุ่มระหว่างโหลด
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                            disabled={isLoading} // ปิดการใช้งานปุ่มระหว่างโหลด
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default Home;